
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AdWxAppClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import FileUpload from 'vue-upload-component'
import request from '@/utils/request'

@Component({
  name: 'AdWxAppEditor',
  components: {
    FileUpload
  }
})
export default class extends BaseEditor {
  adTypeList = [
    { id: 'index', name: '首页展示' },
    { id: 'pay_complete', name: '支付完成页展示' }
  ]

  public constructor() {
    super()
    this.client = new AdWxAppClient()
    this.data = {}
    this.rules = {
      type: [{ required: true, message: '类型必填项', trigger: 'blur' }],
      order: [{ required: true, message: '顺序必填项', trigger: 'blur' }],
      cover_img: [
        { required: true, message: '封面图是必填项', trigger: 'blur' }
      ],
      detail_img: [
        { required: true, message: '详情图是必填项', trigger: 'blur' }
      ]
    }
  }

  public async reset() {
    this.data = {
      id: undefined,
      cover_img: undefined,
      detail_img: undefined,
      url: undefined,
      title: undefined,
      type: undefined,
      order: 1
    }
  }

  protected generateData(): any {
    let data = _.pick(this.data, [
      'type',
      'url',
      'title',
      'order',
      'cover_img',
      'detail_img'
    ])
    data.order = Number(this.data.order)
    return this.clearData(data)
  }

  protected inputFilter(newFile: File, oldFile: File, prevent: Function) {
    if (newFile && !oldFile) {
      // Before adding a file
      // 添加文件前
      // Filter system files or hide files
      // 过滤系统文件 和隐藏文件
      if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
        return prevent()
      }
      // Filter php html js file
      // 过滤 php html js 文件
      if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
        return prevent()
      }
    }
  }

  protected inputCoverFile(newFile: any, oldFile: any) {
    var reader = new FileReader()
    const self = this
    reader.addEventListener(
      'load',
      function() {
        self.data.cover_img = reader.result
      },
      false
    )

    if (newFile) {
      reader.readAsDataURL(newFile.file)
    }
  }

  protected inputDetailFile(newFile: any, oldFile: any) {
    var reader = new FileReader()
    const self = this
    reader.addEventListener(
      'load',
      function() {
        self.data.detail_img = reader.result
      },
      false
    )

    if (newFile) {
      reader.readAsDataURL(newFile.file)
    }
  }

  protected async uploadFile(data: any): Promise<String> {
    const formData = new FormData()
    formData.append('file', data.file)
    const url = await request({
      url: '/minio/adwxapp/random',
      method: 'post',
      data: formData
    })
    return url.toString()
  }

  protected async beforeSave(): Promise<Boolean> {
    const uploadCover = this.$refs['uploadCover'] as any
    if (uploadCover.files.length === 1) {
      this.listLoading = true
      this.data.cover_img = await this.uploadFile(uploadCover.files[0])
      this.listLoading = false
      uploadCover.clear()
    }

    const uploadDetail = this.$refs['uploadDetail'] as any
    if (uploadDetail.files.length === 1) {
      this.listLoading = true
      this.data.detail_img = await this.uploadFile(uploadDetail.files[0])
      this.listLoading = false
      uploadDetail.clear()
    }
    return true
  }
}
